// Import dependencies
import { unsafeCSS, css, html, LitElement, render } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-placeholder' )
export class AutomatorLogPlaceholder extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="log-placeholder">
				<div class="log-placeholder-body">
					<div class="log-placeholder-header">
						<div class="log-placeholder-header-actions">
							<div class="log-placeholder-header-actions-left">
								<div class="log-placeholder-header-actions-group">
									<uo-placeholder width="20px" height="20px"></uo-placeholder>
									<uo-placeholder width="20px" height="20px"></uo-placeholder>
									<uo-placeholder width="20px" height="20px"></uo-placeholder>
								</div>
								<div class="log-placeholder-header-actions-group">
									<uo-placeholder width="20px" height="20px"></uo-placeholder>
								</div>
							</div>
							<div class="log-placeholder-header-actions-right">
								<div class="log-placeholder-header-actions-group">
									<uo-placeholder width="20px" height="20px"></uo-placeholder>
								</div>
							</div>
						</div>
						<h1 class="log-placeholder-title">
							<uo-placeholder width="50px"></uo-placeholder>
							<uo-placeholder width="100px"></uo-placeholder>
							<uo-placeholder width="50px"></uo-placeholder>
							<uo-placeholder width="200px"></uo-placeholder>
						</h1>
						<table class="log-placeholder-summary">
							<tbody>
								<tr>
									<td class="log-placeholder-summary__key">
										<uo-placeholder width="100px"></uo-placeholder>
									</td>
									<td class="log-placeholder-summary__value">
										<div class="log-placeholder-summary-user">
											<uo-placeholder class="log-placeholder-summary-user__avatar-placeholder" width="32px" height="32px"></uo-placeholder>
											<div class="log-placeholder-summary-user__name-placeholder">
												<uo-placeholder width="50px"></uo-placeholder> <uo-placeholder width="70px"></uo-placeholder>
											</div>
											<uo-placeholder class="log-placeholder-summary-user__email-placeholder"></uo-placeholder>
										</div>
									</td>
								</tr>
								<tr>
									<td class="log-placeholder-summary__key">
										<uo-placeholder width="100px"></uo-placeholder>
									</td>
									<td class="log-placeholder-summary__value">
										<uo-placeholder width="200px"></uo-placeholder>
									</td>
								</tr>
								<tr>
									<td class="log-placeholder-summary__key">
										<uo-placeholder width="100px"></uo-placeholder>
									</td>
									<td class="log-placeholder-summary__value">
										<uo-placeholder width="200px"></uo-placeholder>
									</td>
								</tr>
								<tr>
									<td class="log-placeholder-summary__key">
										<uo-placeholder width="100px"></uo-placeholder>
									</td>
									<td class="log-placeholder-summary__value">
										<uo-placeholder width="200px"></uo-placeholder>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="log-placeholder-triggers">
						<h2 class="log-placeholder-section-title">
							<uo-placeholder width="100px"></uo-placeholder>
						</h2>
						<div class="log-placeholder-section-items">
							<div class="log-placeholder-section-item">
								<div class="log-placeholder-section-item__icon">
									<uo-placeholder class="icon-placeholder" width="32px" height="32px"></uo-placeholder>
								</div>
								<div class="log-placeholder-section-item__sentence">
									<uo-placeholder width="100px"></uo-placeholder> <uo-placeholder width="40px"></uo-placeholder> <uo-placeholder width="80px"></uo-placeholder> <uo-placeholder width="100px"></uo-placeholder> <uo-placeholder width="80px"></uo-placeholder>
								</div>
								<div class="log-placeholder-section-item__details">
									<uo-placeholder width="150px"></uo-placeholder>
									<uo-placeholder width="100px"></uo-placeholder>
									<uo-placeholder width="50px"></uo-placeholder>
								</div>
							</div>
						</div>
					</div>
					<div class="log-placeholder-actions">
						<h2 class="log-placeholder-section-title">
							<uo-placeholder width="100px"></uo-placeholder>
						</h2>
						<div class="log-placeholder-section-items">
							<div class="log-placeholder-section-item">
								<div class="log-placeholder-section-item__icon">
									<uo-placeholder class="icon-placeholder" width="32px" height="32px"></uo-placeholder>
								</div>
								<div class="log-placeholder-section-item__sentence">
								<uo-placeholder width="100px"></uo-placeholder> <uo-placeholder width="40px"></uo-placeholder> <uo-placeholder width="80px"></uo-placeholder> <uo-placeholder width="100px"></uo-placeholder> <uo-placeholder width="80px"></uo-placeholder>
								</div>
								<div class="log-placeholder-section-item__details">
								<uo-placeholder width="150px"></uo-placeholder>
									<uo-placeholder width="100px"></uo-placeholder>
									<uo-placeholder width="50px"></uo-placeholder>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		`;
	}
}